export default __webpack_public_path__ + "static/media/ios_step3.b44c0067.png";